var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2414_15003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.61084 10.0039L3.67377 11.2534C3.53127 11.4435 3.30416 11.5664 3.04834 11.5664C2.79252 11.5664 2.56545 11.4435 2.42291 11.2534L1.48584 10.0039",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5171 16.0977L17.58 14.8481C17.4375 14.6581 17.2104 14.5352 16.9546 14.5352C16.6988 14.5352 16.4717 14.6581 16.3292 14.8481L15.3921 16.0977",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04492 6.87891V11.5664",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7012 3.90625H3.04492C2.18199 3.90625 1.48242 3.20668 1.48242 2.34375C1.48242 1.48082 2.18199 0.78125 3.04492 0.78125H10.7012C11.5641 0.78125 12.2637 1.48082 12.2637 2.34375C12.2637 3.20668 11.5641 3.90625 10.7012 3.90625Z",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7012 17.6562H3.04492C2.18199 17.6562 1.48242 16.9567 1.48242 16.0938C1.48242 15.2308 2.18199 14.5312 3.04492 14.5312H10.7012C11.5641 14.5312 12.2637 15.2308 12.2637 16.0938C12.2637 16.9567 11.5641 17.6562 10.7012 17.6562Z",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9512 11.5625H9.29492C8.43199 11.5625 7.73242 10.8629 7.73242 10V8.4375C7.73242 7.57457 8.43199 6.875 9.29492 6.875H16.9512C17.8141 6.875 18.5137 7.57457 18.5137 8.4375V10C18.5137 10.8629 17.8141 11.5625 16.9512 11.5625Z",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9512 19.2188V14.5312",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2414_15003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriority);
export default __webpack_public_path__ + "static/media/Priority.3a8565ea4884d9d07018ba8cb9ac0c02.svg";
export { ForwardRef as ReactComponent };